import { useCallback, useState } from 'react';

const sameValues = (left, right) => {
  const keys = Object.keys(left);
  return keys.length === Object.keys(right).length && keys.every(key =>
    Object.prototype.hasOwnProperty.call(right, key) && Object.is(left[key], right[key]));
};

export const samePreviewPumpRows = (previous, next) => previous === next || (
  Array.isArray(previous) && previous.length === next.length && previous.every((row, index) => (
    row.key === next[index].key &&
    row.isValid === next[index].isValid &&
    sameValues(row.selections, next[index].selections) &&
    sameValues(row.inputs, next[index].inputs)
  ))
);

export default function usePreviewPumpRows() {
  const [rowsByStation, setRowsByStation] = useState({});
  const updateRows = useCallback((stationId, rows) => {
    // The preview can rebuild field objects after a parent render. Reporting
    // identical serialized rows must not trigger another parent/child cycle.
    setRowsByStation(current => samePreviewPumpRows(current[stationId], rows)
      ? current
      : { ...current, [stationId]: rows });
  }, []);
  return [rowsByStation, updateRows, setRowsByStation];
}
